export const IconEth = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M8 16.3859L16.4 2.66663L24.8 16.3859L16.4 21.2795L8 16.3859Z" fill="#6A5ECC" />
            <path
                d="M16.4 22.821L24.5309 17.7731L16.4 29.3333L8.07715 17.7731L16.4 22.821Z"
                fill="#6A5ECC"
            />
        </svg>
    );
};
